import React from "react";
import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import { FileInput } from "@uppy/react";
import "@uppy/core/dist/style.css";
import "@uppy/file-input/dist/style.css";
import "./UploadfilesPage.css";
import { getRequestcall } from "../../comman/util/getRequest";
import { CLEAR_TUS } from "../../constants/apiurl";
import English from "@uppy/locales/lib/en_US";
import Turkish from "@uppy/locales/lib/tr_TR";
import { connect } from "react-redux";
import { StatusBar } from "@uppy/react";
import "@uppy/status-bar/dist/style.css";
import store_uppy_tr from "../../../assets/store_uppy_tr.webp";
import store_uppy_en from "../../../assets/store_uppy_en.webp";

function UploadfilesPage(props) {
  const uppy = new Uppy({
    debug: true,
    locale: props?.language === "Tr" ? Turkish : English,
    meta: {},
    restrictions: {
      allowedFileTypes: ["image/*", ".pdf"],
    },
    autoProceed: true,
    allowMultipleUploadBatches: true,
    onBeforeUpload: (files) => {
      try {
        // We’ll be careful to return a new object, not mutating the original `files`
        const updatedFiles = {};
        Object.keys(files).forEach((fileID) => {
          updatedFiles[fileID] = {
            ...files[fileID],
            meta: {
              ...files[fileID].meta,
              name: Date.now() + "_" + files[fileID].meta.name,
            },
          };
        });
        return updatedFiles;
      } catch (Exception) {
        
      }
    },
  });
  uppy.use(Tus, { endpoint: `${process.env.REACT_APP_BASE_URL}/tus/` });

  uppy.on("complete", async (result) => {
    try {
      let objectURL = URL.createObjectURL(result.successful[0].data);
      let getImage = {};
      result.successful.forEach((item) => {
        getImage = {
          preview_url: objectURL,
          fileName: item.meta.name,
        };
      });
      if (typeof props.storeFiles !== "undefined") {
        props?.storeFiles(getImage, props.type);
      }
    } catch (Exception) {}
    await getRequestcall(CLEAR_TUS, "");
  });

  return (
    <div className="hi">
        {props?.type === "setup-store" && (
          <style>
          {` .uppy-FileInput-container {
            background-image: url(${props?.language === "Tr" ? store_uppy_tr : store_uppy_en });
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            border-radius: 10px
           }
           .uppy-Root .uppy-FileInput-btn {
              background: transparent;
              color:transparent;
              border:0;
              height: 140px !important;
           }
           .uppy-Root .uppy-FileInput-btn:hover{
            background: transparent;
            color: transparent;
            border:0
           }
        `}
      </style>)}
      <FileInput uppy={uppy} inputName="files[]" />
      <StatusBar
        className="status-bar"
        uppy={uppy}
        hideUploadButton
        hideAfterFinish={true}
        hideRetryButton={true}
        hidePauseResumeButton={true}
        hideCancelButton={false}
        showProgressDetails={false}
      />
    </div>
  );
}
const mapStateToProps = (state) => ({
  language: state?.languageState?.language,
});
export default connect(mapStateToProps)(UploadfilesPage);
